<template>
  <base-layout :query="require('@/graphql/Content.gql')" :variables="{slug: slug}">
    <template v-slot:title="props">
        <top v-if="contentData" :titleText="contentData.title" :nameText="contentData.title" class="blue"/>
    </template>
    <template v-slot:main-section="props">
      <div class="page-contact u-bg--white u-align--left">
        <div class="infos">
          <RichText v-if="contentData" :dataHtml="contentData.body"></RichText>
        </div>
      </div>
    </template>
    <template v-slot:card-section="props">
      <card-study :study="props.data.studies.edges[0]" :flatButton="true"></card-study>
      <card-simple-actu :actu="props.data.infos.edges[0]" :flatButton="true"></card-simple-actu>
    </template>
  </base-layout>
</template>

<script>
  import BaseLayout from "../components/Layout/BaseLayout";
  import CardSimpleActu from "../components/Card/Models/Card-simple-actu";
  import CardStudy from "../components/Card/Models/Card-study";
  import Top from "../components/Core/Top";
  import RichText from "../components/Core/RichText";
  import gql from "graphql-tag"
  import { apolloClient } from '@/vue-apollo';

  export default {
    name: "Contact",
    components: {RichText, Top, CardStudy, CardSimpleActu, BaseLayout},
    data: () => {
      return {
        slug: '',
        title: '',
        contentData: false
      }
    },
    watch: {
      "$route.params.slug": function(slug) {
        this.slug = slug;
        this.getContent(slug);
      }
    },

    beforeRouteEnter(to, from, next) {
      // On appelle la requete GQL GetContents() en se basant sur le slug fourni.
      apolloClient.query({
        query: require('../graphql/ContentBySlug.gql'),
        variables: {
          slug: to.params.slug
        }
      })
      // On recupere le node 'contents'
      .then(({ data: { contents } }) => {

        // Si aucun content, alors page not found
        if (!contents.edges.length) {
          next({name: 'not-found'}); // j'aurais aimé conservé rediriger vers not-found sans changer l'url, mais pas trouvé
        } else {
          // sinon on continue.
          next();
        }
      })},


    methods: {
      getContent(slug) {
        const contentQuery = gql`query($slug: String!) {contents(slug: $slug, first: 1) {
                                  edges {
                                    node {
                                      id
                                      title
                                      body
                                      slug
                                      customCss
                                      customJs
                                      createdAt
                                      updatedAt
                                    }
                                  }
                                }},`

        this.$apollo.query({
          query: contentQuery,
          variables: {
            slug: slug
          }
        }).then( result => {
          if (typeof result.data.contents.edges[0].node !== 'undefined') {
            this.contentData = result.data.contents.edges[0].node
          }

          if (result.data.contents.edges[0].node.customCss) {
            this.setCustomCss(result.data.contents.edges[0].node.customCss)
          }
        })
      },
      setCustomCss(customCss) {
        let styleContainer = document.getElementById('custom-css')

        let style = document.createElement('style')
        let inlineStyle = document.createTextNode(customCss)

        style.appendChild(inlineStyle)

        if (styleContainer.childNodes.length) {
          styleContainer.removeChild(styleContainer.childNodes[0])
        }

        styleContainer.appendChild(style)
      }
    },
    mounted() {
      this.slug = this.$route.params.slug
      this.getContent(this.slug)

      let styleContainer = document.createElement('div')
      styleContainer.setAttribute("id", "custom-css")

      this.$el.insertAdjacentElement('afterend', styleContainer)
    }
  }
</script>

<style lang="scss">
  .page-contact {
    border: 1px solid color(border);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
    padding: rem(25px) rem(30px) rem(30px);
    font-size: rem(14px);
    line-height: rem(24px);

    .infos {
      display: flex;
      flex-direction: column;

      span {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        &.address, &.email {
          margin-bottom: rem(20px);
        }

        .tel, .fax {
          text-decoration: none;
        }
      }
    }

    @include mq($until: MD) {
      padding: rem(20px) rem(10px);
      margin: 0 rem(10px);
    }

    h2, h3 {
      padding-top: rem(16px);

      &.title-without-link{
        font-size: rem(22px);
        line-height: rem(24px);
        position: relative;
        padding-bottom: rem(25px);
        margin: 0 0 rem(30px);

        &::after {
          position: absolute;
          content: '';
          left: 0;
          bottom: 0;
          height: 1px;
          width: 100%;
          background-color: color(border);
        }


        @include mq($until: MD) {
          font-size: rem(18px);
        }
      }

      @include mq($until: MD) {
        margin: 0 0 rem(20px);
        padding-bottom: rem(15px);
      }
    }
  }
</style>